export interface ApiPutTranslationTextRequest {
    current_step: string;
    task_id: string;
    original_index: number;
    target_text: string;
}

export const PutTranslationText = Symbol('PutTranslationText');

export interface PutTranslationText {
    putTranslationText(data: ApiPutTranslationTextRequest): Promise<void>;
}